import types from './inviteTypes';
import { takeLatest, all } from 'redux-saga/effects';
import * as actions from './inviteActions';

export default function* customerSagas() {
  yield all([
    yield takeLatest(types.INVITE_CUSTOMER_REQUEST, actions.inviteCustomer),
  ]);
}
